import { DelayedCall } from '../../core/delayed-call';
import { GPSCoordinate } from '../../core/gpscoordinate';
import { StringHelpers } from '../../core/stringhelpers';
import { UserLocation } from '../../core/userlocation';
import { ReceptionOutDatabaseShortInfo, ReceptionSearchInfo, Receptions } from '../../io/receptions';
import { Application } from '../../main';
import { Search } from './search';

import { HtmlPartials } from "../../../../shared/htmlpartials";

export class ReceptionSearch {
    
    static titleText: string;
    static paragraphText: string;

    container: JQuery<HTMLElement>;
    search: Search;
    elm: JQuery<HTMLElement>;
    bottomParagraph: JQuery<HTMLElement>;
    holder: JQuery<HTMLElement>;
    
    constructor(container:JQuery<HTMLElement>) {
        this.container = container;

        let headingElm = this.container.find(".searchHeading");
        let pElm = this.container.find("p");
        if(headingElm.length>0) {
            ReceptionSearch.titleText = headingElm.html();
            headingElm.remove();
        }
        if(pElm.length>0) {
            ReceptionSearch.paragraphText = pElm.html();
            pElm.remove();
        }

        this.holder = $("<div class='map-search-input-holder introtext-visible'></div>").appendTo(this.container);
        this.elm = $("<div class='reception-search'></div>").appendTo(this.holder);
        
        this.search = new Search(this.elm, ReceptionSearch.titleText);

        this.bottomParagraph = $("<p>"+ReceptionSearch.paragraphText+"</p>").appendTo(this.container);

        this.search.on("focus", () => {
            if(this.bottomParagraph!=null) {
                this.bottomParagraph.remove();
                this.bottomParagraph = null;
                this.holder.removeClass("introtext-visible");
                this.search.off("focus");
            }
        });

        let submitDelayedCall:DelayedCall|null = null;
        this.search.on("submit", () => {
            if(submitDelayedCall!=null) {
                submitDelayedCall.cancel();
                submitDelayedCall = null;
            }
            submitDelayedCall = new DelayedCall(async () => {
                let zoomToReceptions:ReceptionOutDatabaseShortInfo[] = [];
                for(let m in Receptions.receptions) {
                    if(!Receptions.receptions[m].marker?.peripheral) {
                        zoomToReceptions.push(Receptions.receptions[m]);
                    }
                }
                Application.map?.setBoundsToIncludeReceptions(zoomToReceptions);
            }, 300, true);
        });

        let lastSearch:string|null = null;
        let noResultSearchDelayedCall:DelayedCall|null = null;
        this.search.on("change", () => {
            if(noResultSearchDelayedCall!=null) {
                noResultSearchDelayedCall.cancel();
                noResultSearchDelayedCall = null;
            }
            let val:string = this.search.value;
            if(val==lastSearch) return;
            lastSearch = val;
            if(val.length<=1) {
                this.search.clear();
                Application.receptionSearchResultCount = 0;
                for(let m in Receptions.receptions) {
                    Receptions.receptions[m].marker?.setPeripheral(false);
                }
            } else {
                this.search.clear();
                let addedSlugs:any = {};
                let matches = Receptions.search(val);
                let resultLimit = 200;
                let resultsAdded = 0;
                let highlightReceptions:ReceptionOutDatabaseShortInfo[] = [];
                if(UserLocation.last()!=null) {
                    matches.sort((a:ReceptionSearchInfo, b:ReceptionSearchInfo) => {
                        let aDistance:number = Receptions.getDistance(UserLocation.last(), a.reception);
                        let bDistance:number = Receptions.getDistance(UserLocation.last(), b.reception);
                        if(aDistance<bDistance) return -1;
                        if(aDistance>bDistance) return 1;
                        return 0;
                    });
                } else {
                    //zoomed in enough to make distance from current position on map relevant?
                    //console.log("Sorting by bounds");
                    let aWithin = 0;
                    matches.sort((a:ReceptionSearchInfo, b:ReceptionSearchInfo) => {
                        if(a.reception.marker.isWithinBounds) aWithin++;
                        if(a.reception.marker.isWithinBounds&&!b.reception.marker.isWithinBounds) return -1;
                        if(!a.reception.marker.isWithinBounds&&b.reception.marker.isWithinBounds) return 1;
                        return 0;
                    });
                    //console.log("aWithin = " + aWithin);
                }
                
                //console.log("matches.length = " + matches.length);
                for(let m in matches) {
                    let c = matches[m];
                    if(resultsAdded<resultLimit) {
                        let autoCompleteElm = this.search.add(c.reception.name, c.reception.address, StringHelpers.distanceToReadable(Receptions.getDistance(UserLocation.last(), c.reception), "ca ", " bort"), val);
                        autoCompleteElm.on("mousedown", () => { //must be mousedown or the input blur will make it
                            //console.log("mousedown");
                            c.reception.marker?.dispatch("click");
                        });
                        /*autoCompleteElm.on("click", () => { //must be mousedown or the input blur will make it
                            console.log("click");
                            //c.reception.marker?.dispatch("click");
                        });*/
                        resultsAdded++;
                    }
                    addedSlugs[c.reception.slug] = c;
                    highlightReceptions.push(c.reception);
                }
                if(highlightReceptions.length>0) {
                    Application.receptionSearchResultCount = resultsAdded;
                    for(let m in Receptions.receptions) {
                        Receptions.receptions[m].marker?.setPeripheral(true);
                    }
                    for(let m in highlightReceptions) {
                        highlightReceptions[m].marker?.setPeripheral(false);
                    }
                } else {
                    Application.receptionSearchResultCount = 0;
                    for(let m in Receptions.receptions) {
                        Receptions.receptions[m].marker?.setPeripheral(false);
                    }
                }
                if(val.length>3&&resultsAdded<=2) {
                    noResultSearchDelayedCall = new DelayedCall(async () => {
                        noResultSearchDelayedCall = null;
                        try {
                            let searchRes = await Application.map?.googlemaps.textSearch(val, "sv", "se", ['natural_feature', 'administrative_area_level_2', 'political', 'route', 'locality'], true);
                            if(searchRes!=null&&searchRes.length>0) {
                                let foundPlaceCoord = GPSCoordinate.parse((searchRes[0] as any).geometry.location.toString());
                                let closestReceptions = Receptions.getClosestTo(foundPlaceCoord);
                                let maxDistanceMeters = 10000;
                                let capMaxDistanceAtResultCount = 5;
                                for(let m in closestReceptions) {
                                    let c = closestReceptions[m];
                                    if(addedSlugs[c.reception.slug]!=null) continue;
                                    let autoCompleteElm = this.search.add(c.reception.name, c.reception.address, StringHelpers.distanceToReadable(Receptions.getDistance(foundPlaceCoord, c.reception), "ca ", " från " + searchRes[0].name), val);
                                    addedSlugs[c.reception.slug] = c;
                                    autoCompleteElm.on("mousedown", () => { //must be mousedown or the input blur will make it
                                        //console.log("mousedown");
                                        c.reception.marker?.dispatch("click");
                                    });
                                    /*autoCompleteElm.on("click", () => { //must be mousedown or the input blur will make it
                                        console.log("click");
                                        //c.reception.marker?.dispatch("click");
                                    });*/
                                    highlightReceptions.push(c.reception);
                                    resultsAdded++;
                                    if(resultsAdded>=capMaxDistanceAtResultCount&&c.distance>maxDistanceMeters) break; //so far and we show the min amount so we stop here
                                    if(resultsAdded>=resultLimit) break;
                                }
                                if(highlightReceptions.length>0) {
                                    Application.receptionSearchResultCount = resultsAdded;
                                    for(let m in Receptions.receptions) {
                                        Receptions.receptions[m].marker?.setPeripheral(true);
                                    }
                                    for(let m in highlightReceptions) {
                                        highlightReceptions[m].marker?.setPeripheral(false);
                                    }
                                } else {
                                    Application.receptionSearchResultCount = 0;
                                    for(let m in Receptions.receptions) {
                                        Receptions.receptions[m].marker?.setPeripheral(false);
                                    }
                                }
                            }
                        } catch(e) {console.error(e);}
                    }, 2000, true);
                }
            }
        });
    }

    public hide() {
        this.elm.addClass("hidden");
    }  
    public show() {
        this.elm.removeClass("hidden");
    }
}